













import { BButton } from "bootstrap-vue";
import rateLimitsIndicator from "../../components/rateLimitsIndicator.vue";

export default {
    components: {
        BButton,
        rateLimitsIndicator,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        buttonId: {
            type: String,
            required: true,
        },
    },
};
